module.exports = __webpack_public_path__ + "img/Help.77cb6f89.svg";